import { Flex } from "antd-mobile";
import React, {
  forwardRef,
  useCallback,
  useImperativeHandle,
  useState,
} from "react";
import "../index.css";

interface NumberInputProps {
  value?: number;
  editable: boolean;
  defaultvalue: number;
  onChange?: (value: number) => void;
}
const NumberInputCell = forwardRef(
  (
    { value, onChange, editable = true, defaultvalue = 1 }: NumberInputProps,
    ref: any
  ) => {
    const [currentValue, setCurrentValue] = useState<number>(defaultvalue);
    const subtract = useCallback(() => {
      if (!editable) {
        return;
      }
      setCurrentValue(currentValue > 1 ? currentValue - 1 : 1);
      onChange?.(currentValue > 1 ? currentValue - 1 : 1);
    }, [currentValue, onChange, editable]);

    const add = useCallback(() => {
      if (!editable) {
        return;
      }
      setCurrentValue(currentValue + 1);
      onChange?.(currentValue + 1);
    }, [currentValue, onChange, editable]);

    useImperativeHandle(ref, () => ({
      getValue: () => {
        return currentValue;
      },
    }));
    return (
      <div className="numberInputWrapper">
        <Flex>
          <Flex.Item onClick={subtract}>－</Flex.Item>
          <Flex.Item>{currentValue}</Flex.Item>
          <Flex.Item onClick={add}>＋</Flex.Item>
        </Flex>
      </div>
    );
  }
);
export default NumberInputCell;
